import { useDispatch, useSelector } from 'react-redux'
import { closeNotRegisteredPopup } from '../../store/slices/ui.slice' // ייבוא הפעולה לסגירת הפופאפ
import { NotRegistered } from './NotRegistered' // קומפוננטת התוכן של הפופאפ
import { images } from '../../services/images.service'
import { Modal } from '../../cmps/RegisterLogin/Modal'

const NotRegisteredPopup = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector((state) => state.ui.showNotRegisteredPopup) // שליטה בסטייט מה-Redux

  const closeModal = () => {
    dispatch(closeNotRegisteredPopup())
  }

  if (!isOpen) return null

  return (
    <Modal onClose={closeModal}>
      <div className="relative">
        {/* כפתור סגירה */}
        <img
          src={images.closeMenu}
          alt="Close Menu"
          className="absolute top-6 left-4 h-12 w-12 hover:scale-105 transition-transform cursor-pointer"
          onClick={closeModal}
        />
        <NotRegistered />
      </div>
    </Modal>
  )
}

export default NotRegisteredPopup
